import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearBonusesAction } from "../bonusesActions";
import { BonusContext } from "../bonusContext";
import { makeSelectAppLoggedIn } from "../../../app/appSelectors";
import { getActivePromocodes } from "../bonusesSelectors";
import _ from "lodash";
import amountFormat from "../../../utils/amountFormat";
import useDepositPromocodesEnd from "../../Deposit/components/DepositPromocodes/hooks/useDepositPromocodesEnd";

const BonusProvider = ({children}) => {
    const dispatch = useDispatch();
    const loggedIn = useSelector(makeSelectAppLoggedIn());
    const activePromocodes = useSelector(getActivePromocodes);

    const welcomePromocode = useMemo(() => {
        return _.find(activePromocodes, {
            promocode: 'welcome',
        });
    }, [activePromocodes]);

    const isHasBonusAvailable = useMemo(() => {
        return !!welcomePromocode;
    }, [welcomePromocode]);

    const { secondsLeft: promocodeSecondsLeft } = useDepositPromocodesEnd(welcomePromocode);

    const availableSecondsLeft = useMemo(() => {
        return promocodeSecondsLeft;
    }, [promocodeSecondsLeft]);

    const bonusAvailablePercent = useMemo(() => {
        return amountFormat(welcomePromocode?.amount);
    }, [welcomePromocode]);

    useEffect(() => {
        if (!loggedIn) {
            dispatch(clearBonusesAction());
        }
    }, [dispatch, loggedIn]);

    return (
        <BonusContext.Provider value={{
            bonusAvailablePercent,
            bonusAvailableSecondsLeft: availableSecondsLeft,
            isHasBonusAvailable
        }}>
            {children}
        </BonusContext.Provider>
    )
}

export default BonusProvider;
